'use strict';
var SlideshowService = /** @class */ (function () {
    /*@ngInject*/
    function SlideshowService($http, $rootScope) {
        this._$http = $http;
        this.$rootScope = $rootScope;
    }
    /*@ngInject*/
    SlideshowService.prototype.getSlides = function () {
        var _this = this;
        var that = this;
        var request = this._$http({
            method: "get",
            url: "api/slideshows/"
        });
        return request.then(function (data) {
            var slides = [];
            var links = [];
            var slideData = data.data.response.currentPage[0].slideShowSlides;
            for (var idx in slideData) {
                links = [];
                /* restructure links */
                for (var idx2 in slideData[idx].slideShowButtonTextsAndLinks[0].buttonTextAndLink) {
                    if (slideData[idx].slideShowButtonTextsAndLinks[0].buttonTextAndLink[idx2].buttonLink) {
                        links.push({
                            text: slideData[idx].slideShowButtonTextsAndLinks[0].buttonTextAndLink[idx2].buttonText,
                            url: slideData[idx].slideShowButtonTextsAndLinks[0].buttonTextAndLink[idx2].buttonLink
                        });
                    }
                }
                /* restructure slides */
                slides.push({
                    id: slideData[idx].slideId,
                    backgroundDesktop: slideData[idx].imageUrl,
                    backgroundMobile: slideData[idx].mobileImageUrl,
                    headerText: slideData[idx].slideHeaderName,
                    detailImage: '',
                    bodyText: slideData[idx].slideDetails.toString().includes('EQP') ? that.insertSubstring(slideData[idx].slideDetails, "SM") : slideData[idx].slideDetails,
                    templateId: '1',
                    links: links
                });
            }
            return slides;
        }).catch(function (err) {
            // TODO: error handler
            console.log('error: failed to load slide images');
        })
            .finally(function () {
            _this.$rootScope.$broadcast('hero-loaded');
        });
    };
    SlideshowService.prototype.insertSubstring = function (str, subStr) {
        var strArr = str.split(' ');
        strArr.splice(strArr.indexOf('(EQP)'), 0, subStr.sup());
        return strArr.join(' ');
    };
    return SlideshowService;
}());
export default SlideshowService;
//# sourceMappingURL=slideshow.service.js.map